<template>
  <div class="section-main-100 pa-9">
    <!-- Заголовок -->
    <h1 class="weight-900 text-h4 mb-6 text-uppercase">О нас</h1>

    <!-- Блок с информацией о предпринимателе -->
    <div class="company-info mt-6">
      <h2 class="weight-700 text-h6 mb-4">Юридическая информация</h2>
      <p><strong>ИП Меркурьева Мария Викторовна</strong></p>
      <p><strong>Телефон:</strong> <a href="tel:+79882574445">+7 (988) 257-44-45</a></p>
      <p><strong>ОГРНИП:</strong> 317619600101031</p>
      <p><strong>ИНН:</strong> 616304742897</p>
      <p><strong>Юридический адрес:</strong> г Ростов на Дону, ул 2-я Воробьиная, 28</p>
    </div>
  </div>
</template>

<script>
import about from '@/assets/about.jpeg'

export default {
  name: 'AboutUs',
  data () {
    return {
      about
    }
  }
}
</script>

<style scoped>
  .company-info {
    max-width: 60%;
    margin-top: 2rem;
    font-size: 1rem;
    line-height: 1.5;
  }
  .company-info p {
    margin: 1rem 0;
  }
  @media (max-width: 800px) {
    .company-info {
      max-width: 100%;
    }
    h1 {
      font-size: 1.8rem;
    }
    .company-info p {
      margin: 0.75rem 0;
    }
  }
</style>
